import React, { useEffect, useState } from "react";
import styled from "styled-components";

const Container = styled.svg`
  cursor: pointer;
  &:hover {
    fill: #c870ef;
    path {
      fill: #fff;
    }
  }

  @media screen and (max-width: 575px) {
    display: hidden;
  }
`;

function SortAsc({ data, Column, Direction, onSort }) {
  return (
    <Container
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => {
        if (data == Column) {
          onSort(data, Direction == "asc" ? "desc" : "asc");
        } else {
          onSort(data, "asc");
        }
      }}
    >
      <line
        x1="3.92529"
        y1="14.8789"
        x2="16.0743"
        y2="14.8789"
        stroke="#1570EF"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="6.12354"
        y1="10.168"
        x2="13.8759"
        y2="10.168"
        stroke="#1570EF"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="8.43652"
        y1="5.45508"
        x2="11.563"
        y2="5.45508"
        stroke="#1570EF"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Container>
  );
}

export default SortAsc;
